import { devConfiguration } from "./config.dev";
import { prodConfiguration } from "./config.prod";

const env =
  process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

export const endpoints =
  env === "production" ? prodConfiguration : devConfiguration;
